import React from "react";

const Firebase = () => {
  return (
    <>
      <div className="text-6xl text-yellow-300 font-special  w-[100%] text-center mt-5 md:text-9xl">
        Firebase Auth
      </div>
      <hr class="h-px mb-5 bg-yellow-300 w-[50%] mx-auto border-0 "></hr>
    </>
  );
};

export default Firebase;
